import "../assets/SpinRotate.css"
const SpinRotate= ()=> {

    return (
    <div className="SpinRotate-div">
    </div>)

}

export default SpinRotate